module.exports = __webpack_public_path__ + "static/37-75c94942175250c36bd4368ff8092cc0.png";